import styled, { css } from 'styled-components';
import { Tag as TagAntd } from 'antd';
import color from '../../configs/color';

const Tag = styled(TagAntd)`
  border-color: transparent;
  border-radius: ${(props) => {
    return props.borderRadius ? props.borderRadius : '100px';
  }};
  background-color: ${color.grey3};
  color: ${color.black2};
  font-size: 14px;
  font-size: ${(props) => {
    return props.fontSize ? props.fontSize : '14px';
  }};
  font-weight: ${(props) => {
    return props.fontWeight ? props.fontWeight : '400';
  }};
  padding: ${(props) => {
    return props.padding ? props.padding : '2px 16px';
  }};
  text-align: center;
  width: ${(props) => {
    return props.width && `${props.width}px`;
  }};

  ${(props) => {
    return (
      props.small &&
      css`
        font-size: 12px;
        padding: 0 16px;
      `
    );
  }};

  ${(props) => {
    return (
      props.color === 'purple' &&
      css`
        color: ${color.purple1};
        background-color: ${color.purple6};
      `
    );
  }}

  ${(props) => {
    return (
      props.color === 'orange' &&
      css`
        color: ${color.orange1};
        background-color: ${color.orange6};
      `
    );
  }}

  ${(props) => {
    return (
      props.color === 'grey' &&
      css`
        color: ${color.black3};
        background-color: ${color.black5} !important;
      `
    );
  }}

    ${(props) => {
    return (
      props.color === 'green' &&
      css`
        color: ${color.green1};
        background-color: ${color.green6};
      `
    );
  }}
  
    ${(props) => {
    return (
      props.color === 'red' &&
      css`
        color: ${color.red1};
        background-color: ${color.red6};
      `
    );
  }};
`;

export default Tag;
